import React from "react";
import { Form } from "react-bootstrap";
import moment from "moment";

const StandardizedDateInput = ({ value, onChange, placeholder = "dd/mm/yyyy", ...props }) => {
    return (
        <Form.Control
            {...props}
            type="date"
            className={`standardized-date-input ${props.className || ""}`}
            data-date={value ? moment(value).format("DD/MM/YYYY") : placeholder}
            value={value || ""}
            onChange={onChange}
        />
    );
};

export default StandardizedDateInput;
